import {useEffect, useState} from 'react';
import {Modal, Backdrop, Icon} from '@mui/material';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';
import {ACCOUNT_DEACTIVATED_EVENT} from 'utils/deactivation';

// Blocks the entire admin panel the instant a deactivation is detected, on
// any tab/request — not just a toast, since the account must not be usable
// at all once deactivated. No onClose handler is wired up on purpose: the
// only way out is the "Go to Sign In" button, which does a hard reload.
export default function DeactivatedOverlay() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleDeactivated = () => setOpen(true);
    window.addEventListener(ACCOUNT_DEACTIVATED_EVENT, handleDeactivated);
    return () =>
      window.removeEventListener(ACCOUNT_DEACTIVATED_EVENT, handleDeactivated);
  }, []);

  if (!open) return null;

  return (
    <Modal open={open} slots={{backdrop: Backdrop}} slotProps={{backdrop: {sx: {backgroundColor: 'rgba(0,0,0,0.85)'}}}}>
      <MDBox
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: {xs: '90%', sm: 420},
          bgcolor: 'background.paper',
          boxShadow: 24,
          borderRadius: 2,
          p: 4,
          textAlign: 'center',
        }}>
        <Icon color="error" fontSize="large" sx={{fontSize: '3rem', mb: 1}}>
          block
        </Icon>
        <MDTypography variant="h5" fontWeight="bold" color="error" gutterBottom>
          Account Deactivated
        </MDTypography>
        <MDTypography variant="body2" color="text" mb={3}>
          Your account has been deactivated by an administrator. You have
          been logged out and can no longer perform any action here. Please
          contact an administrator for assistance.
        </MDTypography>
        <MDButton
          variant="gradient"
          color="error"
          fullWidth
          onClick={() => {
            window.location.href = '/';
          }}>
          Go to Sign In
        </MDButton>
      </MDBox>
    </Modal>
  );
}
